import {updateVehicle} from '../../store/slices/me_slice';
import {store as AppStore} from '../../store/store';
import {isRejected} from '@reduxjs/toolkit';

export async function storeVehicleData(store: typeof AppStore, token: string, formData: FormData) {
    const vehicleId = formData.get('id')?.toString();
    if (vehicleId === null || vehicleId === undefined) {
        throw new Error('No vehicle ID found');
    }

    const tires = formData.get('tires')?.toString() ?? '';
    const lease = formData.get('lease')?.toString() == 'on' ?? false;
    const mileage = formData.get('mileage')?.toString() ?? '';

    const vehicleResult = await store.dispatch(
        updateVehicle({
            token: token,
            tires: tires,
            lease: lease,
            mileage: parseInt(mileage, 10),
            id: parseInt(vehicleId, 10),
        }),
    );
    if (isRejected(vehicleResult)) {
        throw vehicleResult.error;
    }
}
